<template>
  <div v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)">
    <el-switch v-if="type === 'switch'" v-model="innerValue" :active-value="activeValue" :inactive-value="inactiveValue" :active-color="activeColor"
      :inactive-color="inactiveColor" @change="handleChange" :disabled="disabled || loading" size="mini"></el-switch>
    <el-input-number v-else v-model="innerValue" :min="0" :max="9999" size="mini" controls-position="right" @change="handleChange"
      :disabled="disabled || loading" style="width: 80px;"></el-input-number>
  </div>
</template>
<script>
export default {
  name: 'InlineTableControler',
  props: {
    value: {
      type: [Boolean, Number],
      default: false,
    },
    valueKey: {
      type: String,
      default: 'sort',
    },
    type:{
      type: String,
      default: 'switch',      
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    activeColor: {
      type: String,
      default: '#409EFF',
    },
    inactiveColor: {
      type: String,
      default: '#909399', 
    },
    activeValue: {
      type: [Boolean, Number],
      default: 1,
    },
    inactiveValue: {  
      type: [Boolean, Number],
      default: 0,
    },
    customApi: {
      type: String,
      default: '',
    },
    method: {
      type: String,
      default: 'post',
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      innerValue: this.value,
      loading: false,
    };
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  methods: {
    handleChange(value) {
      if (this.loading) {
        return;
      }

      const originalValue = this.innerValue;
      
      this.innerValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
      
      if (this.customApi) {
        this.loading = true;
        
        const requestData = {
          ...this.params, 
          [this.valueKey]: value
        };
        
        this.$post(this.customApi, requestData).then(res => {
          let result = res.data;
          if (result.result === 200) {
            this.$message.success('操作成功');
            this.$emit('refresh');
          } else {
            this.$message.error(result.message || '操作失败');
            this.innerValue = originalValue;
            this.$emit('input', originalValue);
            this.$emit('refresh');
          }
        }).catch(error => {
          console.error('操作失败:', error);
          this.$message.error('操作失败');
          this.innerValue = originalValue;
          this.$emit('input', originalValue);
          this.$emit('refresh');
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666;
  /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }

      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>